import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { TranslationKeysMapper } from '@nimbus-library/features/localization/models/translation-keys.model';

export enum IntervalStatus {
  Open = 'Open',
  Closed = 'Closed',
  Holiday = 'Holiday',
  Special = 'Special',
  Special2 = 'Special2',
  Special3 = 'Special3',
  Special4 = 'Special4',
  None = 'None',
}

export const intervalStatusTranslateMap: TranslationKeysMapper<IntervalStatus> = {
  Closed: TranslationKeys.GeneralIntervalStatusClosed,
  Holiday: TranslationKeys.GeneralIntervalStatusHoliday,
  None: TranslationKeys.GeneralIntervalStatusNone,
  Open: TranslationKeys.GeneralIntervalStatusOpen,
  Special: TranslationKeys.GeneralIntervalStatusSpecial,
  Special2: TranslationKeys.GeneralIntervalStatusSpecial2,
  Special3: TranslationKeys.GeneralIntervalStatusSpecial3,
  Special4: TranslationKeys.GeneralIntervalStatusSpecial4,
};

export enum RangeStatus {
  NoEndDate = 'NoEndDate',
  EndAfterOccurrence = 'EndAfterOccurrence',
  EndBy = 'EndBy',
}

export enum RecurDaysStatus {
  CountDays = 'CountDays',
  EveryWeekday = 'EveryWeekday',
}

export enum OccurrenceOfDays {
  First = 'First',
  Second = 'Second',
  Third = 'Third',
  Fourth = 'Fourth',
  Last = 'Last',
}

export enum DaysOfWeek {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}

export enum RecurMonthStatus {
  Days = 'Days',
  Dow = 'Dow',
}

export enum RecurYearStatus {
  Day = 'Day',
  Dow = 'Dow',
}

export enum MonthList {
  January = 'January',
  February = 'February',
  March = 'March',
  April = 'April',
  May = 'May',
  June = 'June',
  July = 'July',
  August = 'August',
  September = 'September',
  October = 'October',
  November = 'November',
  December = 'December',
}
